import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '..';

const getWrittenCompanyName = createSelector(
  (state: RootState) => state.getStarted.writtenCompanyName,
  writtenCompanyName => writtenCompanyName,
);

const getUserFullName = createSelector(
  (state: RootState) => state.getStarted.userFullName,
  userFullName => userFullName,
);

const getInvitedEmployees = createSelector(
  (state: RootState) => state.getStarted.invitedEmployees,
  invitedEmployees => invitedEmployees,
);

const getRestrictedMailDomains = createSelector(
  (state: RootState) => state.getStarted.restrictedMailDomains,
  restrictedMailDomains => restrictedMailDomains,
);

export const GetStartedSelector = {
  getWrittenCompanyName,
  getUserFullName,
  getInvitedEmployees,
  getRestrictedMailDomains,
};
